module.exports = __webpack_public_path__ + "img/motor-fire-theft-icon.637b628d.svg";